export default __webpack_public_path__ + "static/media/bg_gradi_right03.19c73fc9.png";